import { render } from "./fileslist.vue?vue&type=template&id=4bf195ff&ts=true"
import script from "./fileslist.vue?vue&type=script&lang=ts"
export * from "./fileslist.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__